import { TableCellTypes } from '@carboledger/ui';
import { makeSerialCell } from '@/components/common';
import { SUPPLIER_COLUMNS, SUPPLIER_SORT_FIELDS } from './suppliers.constants';

const canSort = (id) => Boolean(SUPPLIER_SORT_FIELDS[id]);

export const buildSuppliersColumns = (t, { serialOffset = 0 } = {}) =>
  [
    {
      id: SUPPLIER_COLUMNS.serialNo,
      header: t('FIELD_SERIAL_NO'),
      type: TableCellTypes.custom,
      width: 100,
      cell: makeSerialCell(serialOffset),
    },
    {
      id: SUPPLIER_COLUMNS.supplierName,
      header: t('FIELD_SUPPLIER_NAME'),
      type: TableCellTypes.text,
      width: 267,
      pinnable: true,
    },
    {
      id: SUPPLIER_COLUMNS.supplierCode,
      header: t('FIELD_SUPPLIER_ID'),
      type: TableCellTypes.text,
      width: 140,
    },
    {
      id: SUPPLIER_COLUMNS.shippingSitesCount,
      header: t('FIELD_SHIPPING_SITES'),
      type: TableCellTypes.text,
      width: 120,
    },
    {
      id: SUPPLIER_COLUMNS.primaryContact,
      header: t('FIELD_PRIMARY_CONTACT'),
      type: TableCellTypes.text,
      width: 300,
    },
    {
      id: SUPPLIER_COLUMNS.lastUpdated,
      header: t('FIELD_LAST_UPDATED'),
      type: TableCellTypes.date,
      width: 192,
    },
  ].map((column) => ({ ...column, sortable: canSort(column.id) }));
